"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f3939 = void 0;
exports.f3939 = {
    "ལ་དྭགས་ཀྱི་སྐད།": [
        4226
    ]
};
